import React from 'react';
import PropTypes from 'prop-types';
import * as buttonStyles from '../styles/styles.module.scss';
import Key from 'types/Key';

const SubmitButton = ({ text, handler, variant, classes }) => {
  const onKeyPress = event => {
    if (event.key === Key.Enter) {
      handler();
    }
  };

  return (
    <div className={`${buttonStyles[variant]} ${classes}`} onKeyPress={onKeyPress} onClick={handler} tabIndex="0" role="button">
      {text}
    </div>
  );
};

SubmitButton.defaultProps = {
  text: 'submit',
  handler: () => {},
  variant: 'submit',
  classes: ''
};

SubmitButton.propTypes = {
  text: PropTypes.node,
  handler: PropTypes.func,
  variant: PropTypes.string,
  classes: PropTypes.string
};

export default SubmitButton;
